// ColoBongo shared animation presets
export const CB_SPRING = {
  type: "spring",
  stiffness: 300,
  damping: 25,
};

export const CB_SPRING_SOFT = {
  type: "spring",
  stiffness: 200,
  damping: 20,
};

export const CB_EASE = {
  duration: 0.25,
  ease: [0.16, 1, 0.3, 1],
};

export const CB_EASE_SLOW = {
  duration: 0.35,
  ease: [0.16, 1, 0.3, 1],
};

export const fadeInUp = {
  initial: { opacity: 0, y: 12 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: 8 },
  transition: CB_EASE,
};

export const fadeIn = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { duration: 0.2 },
};

export const scaleIn = {
  initial: { opacity: 0, scale: 0.95 },
  animate: { opacity: 1, scale: 1 },
  exit: { opacity: 0, scale: 0.95 },
  transition: CB_SPRING,
};

export const slideInRight = {
  initial: { opacity: 0, x: 20 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -10 },
  transition: CB_EASE,
};

export const staggerContainer = {
  animate: {
    transition: {
      staggerChildren: 0.05,
    },
  },
};

export const staggerItem = {
  initial: { opacity: 0, y: 8 },
  animate: { opacity: 1, y: 0 },
  transition: CB_EASE,
};

export const tapScale = {
  whileTap: { scale: 0.97 },
  transition: { duration: 0.12 },
};

export const hoverLift = {
  whileHover: { y: -2, boxShadow: "var(--cb-shadow-md)" },
  transition: CB_SPRING_SOFT,
};


